module.exports = __webpack_public_path__ + "img/u1186.32389708.svg";